/* MIREN CO. — theme interactions */
(function () {
  'use strict';

  // Mobile nav toggle
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.getElementById('MobileNav');
      if (nav) {
        var open = nav.classList.toggle('open');
        toggle.setAttribute('aria-expanded', String(open));
      }
    }
    var heart = e.target.closest('[data-heart]');
    if (heart) { heart.style.color = 'var(--petrol)'; }
  });

  // Product gallery thumbnails
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var main = document.getElementById('PdpMain');
    var src = thumb.getAttribute('data-full');
    if (main && src) { main.src = src; }
    document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  });

  // Variant selection
  var select = document.getElementById('VariantSelect');
  if (select) {
    var selected = {};
    // init selected from currently-selected option
    document.querySelectorAll('[data-option-position]').forEach(function (group) {
      var pos = group.getAttribute('data-option-position');
      var active = group.querySelector('.variant-opt.active');
      if (active) selected[pos] = active.getAttribute('data-option-value');
    });

    function resolveVariant() {
      var opts = select.options;
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        var match = true;
        for (var pos in selected) {
          var attr = o.getAttribute('data-opt' + pos);
          if (attr !== selected[pos]) { match = false; break; }
        }
        if (match) {
          select.value = o.value;
          var price = document.getElementById('PdpPrice');
          if (price && o.getAttribute('data-price')) price.textContent = o.getAttribute('data-price');
          var addBtn = document.getElementById('AddBtn');
          if (addBtn) {
            if (o.disabled) { addBtn.setAttribute('disabled', 'disabled'); addBtn.textContent = 'Tükendi'; }
            else { addBtn.removeAttribute('disabled'); addBtn.textContent = 'Sepete Ekle'; }
          }
          select.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }

    document.querySelectorAll('[data-option-position]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-option-value]');
        if (!opt) return;
        var pos = group.getAttribute('data-option-position');
        selected[pos] = opt.getAttribute('data-option-value');
        group.querySelectorAll('.variant-opt').forEach(function (o) { o.classList.remove('active'); });
        opt.classList.add('active');
        var label = document.querySelector('[data-selected-for="' + pos + '"]');
        if (label) label.textContent = selected[pos];
        resolveVariant();
      });
    });
  }
})();

/* Hero slideshow */
(function () {
  'use strict';
  document.querySelectorAll('[data-hero-slideshow]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var i = 0, timer = null;
    var speed = (parseInt(root.getAttribute('data-autoplay'), 10) || 6) * 1000;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
    }
    function next() { show(i + 1); }
    function prev() { show(i - 1); }
    function start() { stop(); timer = setInterval(next, speed); }
    function stop() { if (timer) clearInterval(timer); }

    root.querySelector('[data-hero-next]') && root.querySelector('[data-hero-next]').addEventListener('click', function () { next(); start(); });
    root.querySelector('[data-hero-prev]') && root.querySelector('[data-hero-prev]').addEventListener('click', function () { prev(); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-hero-dot'), 10)); start(); }); });

    // swipe
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); start(); }
      x0 = null;
    }, { passive: true });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  });
})();
